import { format } from "date-fns";

export const LIST_NAME_MAX_LENGTH = 255;

const CLASSIFICATIONS_SEPARATOR = " - ";

export const buildListName = (
  classificationNames: string[],
  date: Date = new Date()
): string => {
  const names = classificationNames
    .map((name) => name.trim())
    .filter(Boolean)
    .join(CLASSIFICATIONS_SEPARATOR);

  if (!names) return "";

  const suffix = ` ${format(date, "yyyy-MM-dd HH-mm")}`;
  const maxNamesLength = LIST_NAME_MAX_LENGTH - suffix.length;

  return `${names.slice(0, maxNamesLength).trimEnd()}${suffix}`;
};
